// fetchBaseQuery joins an array param into one comma-separated value, which splits any value that
// itself contains a comma (an alert name, say). Repeating the key per value keeps each one whole,
// and Spring binds the repeats to a list.
export const toQueryString = (
  params: Record<string, string | number | boolean | string[] | undefined>,
): string => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === "") {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((item) => query.append(key, item));
      return;
    }

    query.append(key, String(value));
  });

  const queryString = query.toString();

  return queryString ? `?${queryString}` : "";
};
